import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const cookieSections = [
  ["cookie-meaning", "What cookies are"],
  ["cookie-essential", "Essential cookies"],
  ["cookie-inventory", "Storage we use"],
  ["cookie-optional", "Optional cookies"],
  ["cookie-duration", "Duration"],
  ["cookie-control", "Your controls"],
  ["cookie-contact", "Updates and contact"],
];

function CookiePolicy() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <main className="policy-page cookies">
      <header className="policy-page__hero">
        <div>
          <p className="policy-page__kicker">Legal / Cookies</p>
          <h1>Cookie policy</h1>
        </div>
        <div className="policy-page__intro">
          <p>
            This policy explains how {siteConfig.brandName}, operated by{" "}
            {siteConfig.legalName}, uses browser storage and similar
            technologies.
          </p>
          <span>Last updated / October 2026</span>
        </div>
      </header>
      <div className="policy-page__layout">
        <aside className="policy-page__aside">
          <p className="policy-page__kicker">On this page</p>
          <nav aria-label="Cookie policy sections">
            {cookieSections.map(([id, label]) => (
              <a href={`#${id}`} key={id}>
                {label}
              </a>
            ))}
          </nav>
        </aside>
        <article className="policy-page__content">
          <section id="cookie-meaning">
            <p className="policy-page__section-number">01</p>
            <h2>What cookies are</h2>
            <p>
              Cookies are small data files stored by a browser. Similar
              technologies, such as local storage, can remember information
              between page views. We use the word “cookies” for these
              technologies together.
            </p>
          </section>
          <section id="cookie-essential">
            <p className="policy-page__section-number">02</p>
            <h2>Essential cookies</h2>
            <p>
              Essential storage supports core functions such as keeping items in
              your bag, remembering checkout progress, maintaining security and
              balancing site traffic. These functions cannot be switched off
              through an optional-consent control because the store may not work
              without them.
            </p>
          </section>
          <section id="cookie-inventory">
            <p className="policy-page__section-number">03</p>
            <h2>Storage we currently use</h2>
            <p>
              The store uses local browser storage named <code>storefront-cart</code>
              and <code>storefront-wishlist</code> to retain basket and wishlist
              choices on the same device. During checkout, temporary session
              storage records the pending order number, amount and email so the
              payment-result page can display the correct status.
            </p>
          </section>
          <section id="cookie-optional">
            <p className="policy-page__section-number">04</p>
            <h2>Optional cookies</h2>
            <p>
              We do not currently use advertising cookies or social-media
              tracking pixels. If optional measurement or preference tools are
              added later, they will be used only with consent where required,
              and this policy will be updated before those tools are enabled.
            </p>
          </section>
          <section id="cookie-duration">
            <p className="policy-page__section-number">05</p>
            <h2>Duration</h2>
            <p>
              Local basket and wishlist data remains on the device until it is
              cleared through the store or browser controls. Pending-order
              session data is removed after a successful return from payment and
              otherwise ends when the browser session storage is cleared.
            </p>
          </section>
          <section id="cookie-control">
            <p className="policy-page__section-number">06</p>
            <h2>Your controls</h2>
            <p>
              You can delete or block cookies in your browser settings. Blocking
              essential storage may prevent the bag or checkout from working.
              Where a consent control is presented, you can revisit it to change
              optional choices without affecting essential storage.
            </p>
          </section>
          <section id="cookie-contact">
            <p className="policy-page__section-number">07</p>
            <h2>Updates and contact</h2>
            <p>
              We may update this policy when technologies or legal requirements
              change. Questions can be sent to{" "}
              <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a>
              .
            </p>
          </section>
          <nav className="policy-page__related" aria-label="Related policies">
            <Link to="/privacy" onClick={toTop}>
              Privacy notice
            </Link>
            <Link to="/terms" onClick={toTop}>
              Terms and conditions
            </Link>
            <Link to="/faqs" onClick={toTop}>
              FAQs
            </Link>
          </nav>
        </article>
      </div>
    </main>
  );
}

export default CookiePolicy;
